import { useState, useEffect } from 'react';

import { EventInfo } from '../../../domain';
import { EventHistorySkeletonRow } from './EventHistorySkeletonRow';

interface SkeletonRowsProps {
  isLoading: boolean;
  userEvents: EventInfo[];
}

export const SkeletonRows = ({ isLoading, userEvents }: SkeletonRowsProps) => {
  const [eventHistoryBeforeLoading, setEventHistoryBeforeLoading] = useState(userEvents.length);
  const DEFAULT_SKELETON_ROW_COUNT = 5;
  const skeletonRowCount = eventHistoryBeforeLoading || DEFAULT_SKELETON_ROW_COUNT;
  useEffect(() => {
    if (!isLoading) {
      setEventHistoryBeforeLoading(userEvents.length);
    }
  }, [isLoading, eventHistoryBeforeLoading]);

  return (
    <>
      {new Array(skeletonRowCount).fill(null).map((_, i) => (
        <EventHistorySkeletonRow key={`event-history-skeleton-${i}`} index={i} />
      ))}
    </>
  );
};
